import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "submit"]
  static values = { clearInputDefaultEvent: Boolean }

  connect() {
    if (this.hasSubmitTarget) {
      this.updateSubmit()
    }
  }

  updateSubmit() {
    if (this.allInputsEmpty()) {
      this.submitTarget.disabled = true
    } else {
      this.submitTarget.disabled = false
    }
  }

  clear(event) {
    if (this.hasClearInputDefaultEvent?.value) { event.preventDefault(); }

    this.clearNestedForms()
    this.clearRegularInputs()
  }

  clearNestedForms() {
    const nestedFormWrappers = this.element.querySelectorAll('.nested-form-wrapper')
    nestedFormWrappers.forEach(wrapper => {
      const removeButton = wrapper.querySelector('[data-action="nested-form#remove"]')
      if (removeButton) { removeButton.click(); }
    })
  }

  clearRegularInputs() {
    let clearableInputs = this.inputTargets.filter(input => {
      return !input.closest('[data-controller="nested-form"]')
    })

    if (this.data.has("relatedSelector")) {
      const relatedInputs = Array.from(document.querySelectorAll(this.data.get("relatedSelector")))
        .filter(input => !input.closest('[data-controller*="nested-form"]'))
      clearableInputs = clearableInputs.concat(relatedInputs)
    }

    clearableInputs.forEach((input) => {
      switch (input.type) {
        case "checkbox":
        case "radio":
          input.checked = input.dataset.clearValue || false
          break
        case "select-one":
          input.selectIndex = input.dataset.clearValue || 0
        default:
          input.value = input.dataset.clearValue || ""
      }
    })
  }

  // Private
  allInputsEmpty() {
    return this.inputTargets.map((input) => {
      if (input.type === "checkbox" || input.type === "radio") {
        return !input.checked
      }
      else {
        return input.value === ""
      }
    }).every(value => value === true)
  }
}
